import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  const pillars = [{
    num: '01',
    title: 'Neuroplasticidad',
    desc: 'Re-cableado del SAR para que tu cerebro detecte oportunidades económicas que antes filtraba como invisibles.'
  }, {
    num: '02',
    title: 'Regulación Somática',
    desc: 'Liberación del trauma financiero almacenado en el sistema nervioso a través de técnicas de regulación vagal científicamente respaldadas.'
  }, {
    num: '03',
    title: 'Escritura Neural',
    desc: 'Técnica de escritura que se comunica con el subconsciente en el lenguaje que el cerebro acepta como real.'
  }];
  return <section className="bg-secondary py-10 md:py-16 px-4 md:px-12" data-id="element-276">
      <div className="max-w-6xl mx-auto" data-id="element-277">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 md:mb-16" data-id="element-278">
          <div className="inline-block px-4 py-1.5 rounded-full bg-gold/10 text-gold text-sm font-inter font-bold tracking-widest mb-4 md:mb-6 border border-gold/30" data-id="element-279">
            LA SOLUCIÓN
          </div>
          <p className="font-playfair italic text-lg md:text-xl text-warm-muted mb-3 md:mb-4" data-id="element-280">
            Presentamos
          </p>
          <h2 className="font-playfair font-extrabold text-4xl md:text-7xl text-gold mb-3 md:mb-4" data-id="element-281">
            El Protocolo RNS
          </h2>
          <div className="font-inter font-light tracking-[0.15em] md:tracking-[0.2em] text-warm-white text-base md:text-xl mb-6 md:mb-8 uppercase" data-id="element-282">
            Re-programación Neuro-Somática
          </div>
          <p className="font-inter text-base md:text-lg text-warm-muted max-w-3xl mx-auto leading-relaxed px-2" data-id="element-283">
            Un sistema de 21 días que combina neuroplasticidad, regulación del
            sistema nervioso y Escritura Neural para eliminar el bloqueo
            financiero desde su raíz biológica — no desde el pensamiento
            positivo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8" data-id="element-284">
          {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-card rounded-xl p-6 md:p-8 border-t-4 border-gold flex flex-col items-center text-center shadow-lg" data-id="element-285">
              <div className="font-playfair font-bold text-5xl md:text-6xl text-gold mb-4 md:mb-6 opacity-80" data-id="element-286">
                {pillar.num}
              </div>
              <h3 className="font-playfair font-bold text-xl md:text-2xl text-warm-white mb-3 md:mb-4" data-id="element-287">
                {pillar.title}
              </h3>
              <p className="font-inter text-sm md:text-base text-warm-muted leading-relaxed" data-id="element-288">
                {pillar.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}